// import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
// import "bootstrap/dist/css/bootstrap.min.css"
// import "bootstrap-icons/font/bootstrap-icons.css"
// import "./components/styles/App.css"

// // Components
// import TopBar from "./components/TopBar"
// import Header from "./components/Header"
// import Footer from "./components/Footer"

// // Pages
// import HomePage from "./pages/Home"
// import AboutPage from "./pages/About"
// import ContactPage from "./pages/Contact"
// import SolutionsPage from "./pages/Solution"
// import SolutionDetail from "./pages/SolutionDetails"
// import Product from "./pages/Products"
// import ProductDetail from "./pages/Productdetails"
// function App() {
//   return (
//     <Router>
//       <div className="app-container">
//         <TopBar />
//         <Header />
//         <main>
//           <Routes>
//             <Route path="/Sunshiny" element={<HomePage />} />
//             <Route path="/about" element={<AboutPage />} />
//             <Route path="/solutions" element={<SolutionsPage />} />
//             <Route path="/product" element={<Product />} />
//             <Route path="/product/:id" element={<ProductDetail />} />
//             <Route path="/solutions/:solutionId" element={<SolutionDetail />} />
//             <Route path="/contact" element={<ContactPage />} />
//           </Routes>
//         </main>
//         <Footer />
//       </div>
//     </Router>
//   )
// }

// export default App

// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap-icons/font/bootstrap-icons.css";
// import "./components/styles/App.css";

// // Components
// import TopBar from "./components/TopBar";
// import Header from "./components/Header";
// import Footer from "./components/Footer";

// // Pages
// import HomePage from "./pages/Home";
// import AboutPage from "./pages/About";
// import ContactPage from "./pages/Contact";
// import SolutionsPage from "./pages/Solution";
// import SolutionDetail from "./pages/SolutionDetails";
// import Product from "./pages/Products";
// import ProductDetail from "./pages/Productdetails";

// function App() {
//   return (
    // <Router basename="/Sunshiny">
    //   <div className="app-container">
    //     <TopBar />
    //     <Header />
    //     <main>
    //       <Routes>
    //         <Route path="/" element={<HomePage />} />
    //         <Route path="/about" element={<AboutPage />} />
    //         <Route path="/solutions" element={<SolutionsPage />} />
    //         <Route path="/product" element={<Product />} />
    //         <Route path="/product/:id" element={<ProductDetail />} />
    //         <Route path="/solutions/:solutionId" element={<SolutionDetail />} />
    //         <Route path="/contact" element={<ContactPage />} />
    //       </Routes>
    //     </main>
    //     <Footer />
    //   </div>
    // </Router>
//   );
// }

// export default App;

import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./components/styles/App.css";

// Components
import TopBar from "./components/TopBar";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import ContactPage from "./pages/Contact";
import SolutionsPage from "./pages/Solution";
import SolutionDetail from "./pages/SolutionDetails";
import Product from "./pages/Products";
import ProductDetail from "./pages/Productdetails";

function App() {
  return (
    <Router>
      <div className="app-container">
        <TopBar />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/solutions" element={<SolutionsPage />} />
            <Route path="/product" element={<Product />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/solutions/:solutionId" element={<SolutionDetail />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
